import {combineReducers} from "redux";
import uiReducer from "../modules/ui.ducks";
import activityReducer from "../modules/activity.ducks";
import salaryReducer from "../modules/salary.ducks";
import detailsRouter from "../modules/details.ducks";
import addressReducer from "../modules/addresses.ducks";
import joinReducer from "../modules/join.ducks";

export interface IReducerGlobalState {
    SHOP_URL?: string,
    ACCOUNTS_URL?: string,
    REST_API ?: string,
    LOGIN_URL?: string,
    EP_ADMIN_URL?: string,
    SSO_USER?: any
}

// get the ssoUser detail stored in localStorage
const getSsoData = () => {
    let ssoUserData = localStorage.getItem('ssoUser');
    let parsedSsoData = JSON.parse(ssoUserData as string);
    return parsedSsoData;
}

const getShopUrl = () => {
    let RedirectDomainName = "https://www.eachperson.com/rewards";
    if(window.location.hostname === "qa.eachperson.com"){
        RedirectDomainName = "https://qa.eachperson.com/rewards"
    } else if(window.location.hostname === "stag.eachperson.com"){
        RedirectDomainName = "https://stag.eachperson.com/rewards"
    } else if(window.location.hostname === "www.eachperson.com" ){
        RedirectDomainName = "https://www.eachperson.com/rewards"
    } else if(window.location.hostname === "localhost") {
        RedirectDomainName = "https://qa.eachperson.com/rewards"
    }
    return RedirectDomainName;
}

const getAccountsURL = () => {
    let RedirectDomainName = "https://www.eachperson.com/profile";
    if(window.location.hostname === "qa.eachperson.com"){
        RedirectDomainName = "https://qa.eachperson.com/profile"
    } else if(window.location.hostname === "stag.eachperson.com"){
        RedirectDomainName = "https://stag.eachperson.com/profile"
    } else if(window.location.hostname === "www.eachperson.com" ){
        RedirectDomainName = "https://www.eachperson.com/profile"
    } else if(window.location.hostname === "localhost") {
        RedirectDomainName = "http://localhost:3000/profile"
    }
    return RedirectDomainName;
}

const getRestAPI = () => {
    let RedirectDomainName = undefined;
    if(window.location.hostname === "qa.eachperson.com"){
        RedirectDomainName = "https://qa.eachperson.com/epoints"
    } else if(window.location.hostname === "stag.eachperson.com"){
        RedirectDomainName = "https://stag.eachperson.com/epoints"
    } else if(window.location.hostname === "www.eachperson.com" ){
        RedirectDomainName = "https://www.eachperson.com/epoints"
    } else if(window.location.hostname === "localhost") {
        RedirectDomainName = "http://localhost:3000/profile"
    }
    return RedirectDomainName;
};

const getEPLoginURL = () => {
    return `${eachpersonAdminURL()}/login?redirect_uri=`
}

const eachpersonAdminURL = () => {
    let RedirectDomainName = "https://www.eachperson.com/dashboard";
    if(window.location.hostname === "qa.eachperson.com"){
        RedirectDomainName = "https://qa.eachperson.com/dashboard"
    } else if(window.location.hostname === "stag.eachperson.com"){
        RedirectDomainName = "https://stag.eachperson.com/dashboard"
    } else if(window.location.hostname === "www.eachperson.com" ){
        RedirectDomainName = "https://www.eachperson.com/dashboard"
    } else if(window.location.hostname === "localhost") {
        RedirectDomainName = "http://localhost:4200/dashboard"
    }
    return RedirectDomainName;
}

const global = (): IReducerGlobalState => ({
    ACCOUNTS_URL: getAccountsURL(),
    REST_API: getRestAPI(),
    SHOP_URL: getShopUrl(),
    LOGIN_URL: getEPLoginURL(),
    EP_ADMIN_URL: eachpersonAdminURL(),
    SSO_USER: getSsoData()
});

export const reducers = combineReducers({
    global,
    ui: uiReducer,
    activity: activityReducer,
    salary: salaryReducer,
    details: detailsRouter,
    address: addressReducer,
    join: joinReducer
});

/**
 * some html entity characters cannot parse characters like &nbsp; &pound; if directly displayed as string.
 * so, they should be displayed inside innerHTML.
 */
export function decodeHtmlEntities(html: any) {
    var txt = document.createElement('div');
    txt.innerHTML = html;
    return txt;
  }